import { IconButton, Typography } from '@one-thd/sui-atomic-components';
import { Location, OrderTracking } from '@one-thd/sui-icons';
import React from 'react';
import {
  IShipmentTrackingDetail,
  ITrackShipmentData,
  ITrackingEvent,
} from '../../../models/order-details/track-shipment';
import { dateFormat, formatCityState, timeFormat } from '../util/format';

const TrackShipmentDetails = ({
  shipmentTrackingDetail,
}: ITrackShipmentData) => {
  const {
    trackingNo = '',
    providerName = '',
    currentShipStatus = '',
    deliveredDate = '',
    estimatedDeliveryDate = '',
    eventDetails,
  } = shipmentTrackingDetail as IShipmentTrackingDetail;

  const { trackingEvent } = eventDetails;

  const deliveryDate = deliveredDate || estimatedDeliveryDate;

  const formatDate = 'LLL dd';
  const trackingHistory = trackingEvent.map((trackEvent: object, i: number) => {
    const { address, eventDetail, date, time } = trackEvent as ITrackingEvent;
    if (!eventDetail) {
      return null;
    }
    const key = `tracking-event-${i}`;
    const eventDetailUpper = eventDetail.toUpperCase();
    const iconImage = ['DELIVERED', 'DELIVERED.'].includes(eventDetailUpper)
      ? Location
      : OrderTracking;

    return (
      <div key={key}>
        <div className="sui-flex sui-flex-row sui-text-align ">
          <div className="sui-flex sui-flex-row sui-w-1/3 sui-self-center ">
            <IconButton
              icon={iconImage}
              data-automation-id={`trackingEventIcon${i}`}
            />
            <div className="sui-flex sui-flex-col">
              <Typography data-automation-id={`trackingEventDate${i}`}>
                {dateFormat(date, formatDate)}
              </Typography>
              <Typography data-automation-id={`trackingEventTime${i}`}>
                {timeFormat(time)}
              </Typography>
            </div>
          </div>
          <div
            data-automation-id={`trackingEventLocation${i}`}
            className="sui-self-center sui-w-1/3"
          >
            {formatCityState(address)}
          </div>
          <div
            data-automation-id={`trackingEventDetail${i}`}
            className="sui-self-center sui-w-1/3"
          >
            {eventDetail}
          </div>
        </div>
        <hr />
      </div>
    );
  });

  return (
    <>
      <div className="sui-flex sui-flex-col sui-my-4">
        <Typography weight="bold" data-test-id="delivery-text">
          {deliveredDate ? 'Delivered On' : 'Estimated Delivery'}
        </Typography>
        <Typography>{dateFormat(deliveryDate, formatDate)}</Typography>
      </div>
      <div className="sui-flex sui-flex-row sui-gap-4 sui-my-4">
        <div className="sui-flex sui-flex-col">
          <Typography weight="bold">Status</Typography>
          <Typography>{currentShipStatus}</Typography>
        </div>
        <div className="sui-flex sui-flex-col">
          <Typography weight="bold">Tracking Number</Typography>
          <Typography date-test-id="tracking-number-value">
            {trackingNo}
          </Typography>
        </div>
        <div className="sui-flex sui-flex-col">
          <Typography weight="bold">Shipping Provider</Typography>
          <Typography date-test-id="provider-name-value">
            {providerName}
          </Typography>
        </div>
      </div>
      <Typography>Tracking History</Typography> <hr />
      {trackingHistory}
    </>
  );
};

export default TrackShipmentDetails;
